<template>
  <div v-if="fields.length">
    <v-row :class="{ 'ma-0': optional }">
      <v-col
        v-for="field in fields"
        :key="field.id"
        cols="12"
        lg="6"
        :class="{ 'pt-0': optional }"
      >
        <v-btn
          v-if="!isFieldVisible(field)"
          text
          color="secondary"
          large
          style="margin-top: 15px; margin-bottom: 15px;"
          @click="expandedFieldIds.push(field.id)"
        >Lägg till {{ field.name }}</v-btn>
        <template v-else>
          <div v-if="!field.applicable" class="text-caption">{{ field.archived ? 'Arkiverat fält — sparat svar' : 'Sparat svar — gäller inte längre' }}</div>
          <div v-if="field.retained_answer !== null && field.retained_answer !== undefined" class="text-caption mb-2">Tidigare sparat svar: {{ field.retained_answer }}</div>
          <v-select
            v-if="field.type === 'choice'"
            :value="field.value"
            :items="field.options"
            item-text="label"
            item-value="id"
            :label="field.name"
            clearable
            outlined
            :hint="field.description"
            persistent-hint
            @input="setFieldAnswer(field, $event)"
          ></v-select>
          <div v-else-if="field.type === 'boolean'">
            <div class="text-body-2 text--secondary mb-2">{{ field.name }}</div>
            <v-radio-group
              :value="field.value"
              :aria-label="field.name"
              :mandatory="false"
              :hint="field.description"
              persistent-hint
              row
              class="mt-0 pt-0"
              @change="setFieldAnswer(field, $event)"
            >
              <v-radio label="Ja" :value="true" color="secondary" @click.native.capture="clearSelectedBooleanAnswer(field, true, $event)"></v-radio>
              <v-radio label="Nej" :value="false" color="secondary" @click.native.capture="clearSelectedBooleanAnswer(field, false, $event)"></v-radio>
            </v-radio-group>
          </div>
          <v-text-field
            v-else
            :value="field.value"
            :label="field.name"
            :suffix="field.type === 'number' ? field.unit : null"
            clearable
            outlined
            :hint="field.description"
            persistent-hint
            @input="setFieldAnswer(field, $event)"
          ></v-text-field>
          <v-alert
            v-if="field.error"
            dense
            text
            type="warning"
            class="mt-1"
          >{{ field.error }} Bokningen kan sparas ändå.</v-alert>
        </template>
      </v-col>
    </v-row>
    <v-alert v-if="error" dense type="warning">{{ error }}</v-alert>
  </div>
</template>
<script>
import BookingFieldsService from '@/services/BookingFieldsService'
export default {
  name: 'BookingFields',
  props: {
    booking: {
      type: Object,
      required: true
    },
    optional: Boolean
  },
  data: () => ({
    expandedFieldIds: [],
    fields: [],
    error: null,
    formRequestId: 0
  }),
  computed: {
    contextKey () { return JSON.stringify({ ...this.context, type: this.booking.type }) },
    context () {
      const booking = this.booking
      return {
        booking_id: booking.id || null,
        category_id: booking.category?.id,
        lodging_type_id: booking.lodgingType?.id,
        check_in: booking.checkIn?.format('YYYY-MM-DD'),
        check_out: booking.checkOut?.format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    clearSelectedBooleanAnswer (field, value, event) {
      if (field.value === value) {
        event.preventDefault()
        // Prevent Vuetify from selecting the answer again during the same click.
        event.stopImmediatePropagation()
        this.setFieldAnswer(field, null)
      }
    },
    isFieldVisible (field) {
      return !this.optional || this.expandedFieldIds.includes(field.id) ||
        (field.value !== null && field.value !== undefined && field.value !== '') ||
        (field.retained_answer !== null && field.retained_answer !== undefined && field.retained_answer !== '')
    },
    async loadFields () {
      const formRequestId = ++this.formRequestId
      if (!this.context.category_id || !this.context.check_in || !this.context.check_out || this.booking.type === 'season') { this.fields = []; return }
      try {
        const { data } = await BookingFieldsService.getForm(this.context)
        if (formRequestId !== this.formRequestId) { return }
        if (data.status !== 'success') { this.error = data.error_message || data.message || 'Bokningsfälten kunde inte hämtas. Bokningen kan sparas ändå.'; return }
        this.fields = data.data.fields.map(field => {
          const change = this.booking.booking_field_changes?.find(change => change.field_id === field.id)
          return change ? { ...field, value: change.operation === 'clear' ? null : change.value, error: null } : field
        })
        this.error = null
      } catch (error) {
        if (formRequestId === this.formRequestId) { this.error = error.response?.data?.error_message || error.response?.data?.message || error.message || 'Bokningsfälten kunde inte hämtas. Bokningen kan sparas ändå.' }
      }
    },
    setFieldAnswer (field, value) {
      const changes = (this.booking.booking_field_changes || []).filter(change => change.field_id !== field.id && (!field.predefined_key || this.fields.find(candidate => candidate.id === change.field_id)?.predefined_key !== field.predefined_key))
      changes.push(value === null || value === ''
        ? {
            field_id: field.id,
            operation: 'clear'
          }
        : {
            field_id: field.id,
            operation: 'set',
            value
          })
      this.$set(this.booking, 'booking_field_changes', changes)
      field.value = value
      field.error = null
    }
  },
  watch: {
    contextKey: {
      immediate: true,
      handler () { this.loadFields() }
    }
  },
  beforeDestroy () { this.formRequestId++ }
}
</script>
